import * as pdfjsLib from "pdfjs-dist";

// Serve the module worker with a .js extension. Some production web servers
// (including otherwise valid nginx installations) serve .mjs as
// application/octet-stream, which browsers reject for module workers. The
// prestart/prebuild script copies PDF.js' worker into public/ under this name.
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

export default pdfjsLib;
